import { gql } from '@apollo/client'

export const GET_DAILY_PRICE = gql`
    query BookingGetDailyPrice(
        $lot_id: String!
        $end_datetime: timestamptz!
        $start_datetime: timestamptz!
        $pricing_type: BookingPricingModelType!
    ) {
        booking_get_price(
            lot_id: $lot_id
            end_datetime: $end_datetime
            start_datetime: $start_datetime
            pricing_type: $pricing_type
        ) {
            price
        }
    }
`
